import {enableProdMode, ErrorHandler, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {environment} from './environments/environment';
import {browserTracingIntegration, createErrorHandler, init, TraceService} from '@sentry/angular';
import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from './app/components/app.component';
import {ReactiveFormsModule} from '@angular/forms';
import {SpotlightProductsComponent} from './app/generic/component/products/spotlight.products.component';
import {SpotlightProductsWrapperComponent} from './app/generic/component/products/spotlight.products.wrapper.component';
import {HookParserEntry, provideDynamicHooks} from 'ngx-dynamic-hooks';
import {FilePondModule, registerPlugin} from 'ngx-filepond';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import {ZXingScannerModule} from '@zxing/ngx-scanner';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {NgxPaginationModule} from 'ngx-pagination';
import {appRoutes} from './app/configuration/app.routing';
import {provideRouter, Router, withRouterConfig} from '@angular/router';
import {applicationServices} from './app/configuration/app.features';
import {genericImports, genericProviders} from './app/generic/configuration';

registerPlugin(
	FilePondPluginFileValidateSize,
	FilePondPluginImageTransform,
	FilePondPluginFileValidateType,
	FilePondPluginImageExifOrientation,
);

const componentParsers: Array<HookParserEntry> = [
	{
		component: SpotlightProductsWrapperComponent,
	},
	{
		component: SpotlightProductsComponent,
	},
];

if (environment.production) {
	enableProdMode();
}

if (environment.sentryEnvironment !== 'development') {
	init({
		dsn: 'https://1788ecdd1d7544298f253d530a094bc7@o4512254543462480.ingest.de.sentry.io/4512254543528021',
		release: '14.2.0',
		environment: environment.sentryEnvironment,
		integrations: [
			browserTracingIntegration()
		],
		tracesSampleRate: 0.5,
		ignoreErrors: [
			// Animatie-engine error door onSameUrlNavigation: 'reload' feedback-loop bij snelle navigatie.
			'Cannot read properties of null (reading \'sequence\')'
		],
	});
}

bootstrapApplication(AppComponent, {
	providers: [
		provideZoneChangeDetection({eventCoalescing: true}),
		importProvidersFrom(genericImports, NgxPaginationModule, AngularSvgIconModule.forRoot(), ZXingScannerModule, FilePondModule, ReactiveFormsModule),
		provideDynamicHooks({parsers: componentParsers}),
		...genericProviders,
		...applicationServices,
		{
			provide: ErrorHandler,
			useValue: createErrorHandler({
				showDialog: false,
			}),
		},
		{
			provide: TraceService,
			deps: [Router],
		},
		provideRouter(appRoutes,
			withRouterConfig({
				onSameUrlNavigation: 'reload'
			}),
		)
	]
})
	.catch(err => console.error(err));
